<template>
  <div>
    <b-row>
      <b-col sm="9">
        <Select title="Tipo de Pagamento" field="typePayment" :required="true" :markFormDirty="false"
          v-model="paymentSupplierOrder.typePayment" url="/api/v1/finance/type-payment/select-all"
          :showNewRegister="true" nameNewRegister="typePaymentCreateUpdate" titleNewRegister="Tipo de Pagamento"
          :widthNewRegister="500" :heightNewRegister="250">
          <TypePaymentCreateUpdate :registerInSelect="true" v-model="paymentSupplierOrder.typePayment" />
        </Select>
      </b-col>
      <b-col sm="3">
        <InputDecimal title="Valor" field="value" :formName="formName" :required="true" :markFormDirty="false"
          :maxLength="5" type="float" v-model="paymentSupplierOrder.value" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">
        <DateTime title="Vencimento" field="dueDate" format="DD/MM/YYYY" type="date" placeholder :formName="formName"
          :required="true" v-model="paymentSupplierOrder.dueDate" />
      </b-col>
      <b-col sm="9">
        <InputText title="Descrição" field="name" :formName="formName" :required="false" :maxLength="50"
          v-model="paymentSupplierOrder.description" :markFormDirty="false" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="btnSavePayment" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="savePayment" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import InputDecimal from "@nixweb/nixloc-ui/src/component/forms/InputDecimal";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import CheckboxGroup from "@nixweb/nixloc-ui/src/component/forms/CheckboxGroup";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import TypePaymentCreateUpdate from "../../finance/type-payment/TypePaymentCreateUpdate.vue";

import PaymentSupplierOrder from "@/components/modules/supplier/payment-supplier-order/PaymentSupplierOrder.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "PaymentSupplierOrderCreateUpdate",
  components: {
    InputText,
    InputDecimal,
    DateTime,
    Select,
    Button,
    CheckboxGroup,
    TypePaymentCreateUpdate,
  },
  props: {
    supplierOrderId: String,
    status: Number
  },
  data() {
    return {
      formName: "paymentSupplierOrderCreateUpdate",
      paymentSupplierOrder: new PaymentSupplierOrder(),
      urlCreate: "/api/v1/supplier-order/payment-supplier/create",
      urlUpdate: "/api/v1/supplier-order/payment-supplier/update",
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    ...mapGetters("user", ["hasRule"]),
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi"]),
    ...mapMutations("generic", [
      "addEvent",
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    savePayment() {
      this.paymentSupplierOrder.supplierOrderId = this.supplierOrderId;
      this.paymentSupplierOrder.status = this.status;

      if (this.paymentSupplierOrder.id) {
        let params = { url: this.urlUpdate, obj: this.paymentSupplierOrder };
        this.putApi(params).then((response) => {
          if (response.success) this.hideModal();
          this.removeLoading(["btnSavePayment"]);
        });
      } else {
        let params = { url: this.urlCreate, obj: this.paymentSupplierOrder };
        this.postApi(params).then((response) => {
          if (response.success) this.hideModal();
          this.removeLoading(["btnSavePayment"]);
        });
      }

      this.addEvent({ name: "paymentSupplierUpdated" });
    },
    update(data) {
      this.paymentSupplierOrder = new PaymentSupplierOrder();
      this.paymentSupplierOrder.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "paymentSupplierOrderCreate") {
          this.resetValidation(this.formName);
          this.paymentSupplierOrder = new PaymentSupplierOrder();
        }
        if (event.name == "paymentSupplierOrderUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
